import { ORDER_PAGE_DAILY_CHART_ID } from '../../assets/constants';

import { GraphPresetState, GraphPresetStateByKey, initialGraphPresetStateByKey, initialOrderGraphPresetStateByKey } from './state';

export const getGraphPresetStateByKey = (barChartId: number, graphPresetState: GraphPresetState): GraphPresetStateByKey => {
  const state = graphPresetState[barChartId];
  if (!state) {
    return barChartId === ORDER_PAGE_DAILY_CHART_ID ? initialOrderGraphPresetStateByKey : initialGraphPresetStateByKey;
  }
  return state;
};
